import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=06dddadf&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/components/contact-form.less?vue&type=style&index=0&id=06dddadf&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dddadf",
  null
  
)

export default component.exports